<template>
  <v-row justify="center">
    <v-dialog v-model="visible" persistent max-width="600px">
      <v-form ref="form" @submit.prevent="handleSubmit">
        <v-card v-if="account" :loading="loading">
          <v-card-title>
            <span class="headline">{{$t('modal.editAccount.title')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-alert v-if="error" border="left" colored-border type="error" elevation="2">
                    {{error}}
                  </v-alert>
                </v-col>

                <!-- address -->
                <v-col cols="6">
                  <v-text-field :label="$t('label.address')" v-model="account.address" :rules="[rules.required]" @click.native="enableSave()" />
                </v-col>

                <!-- city -->
                <v-col cols="6">
                  <v-text-field :label="$t('label.city')" v-model="account.city" :rules="[rules.required]" @click.native="enableSave()" />
                </v-col>

                <!-- phone -->
                <v-col cols="6">
                  <v-text-field :label="$t('label.phone')" v-model="account.phone" :rules="[rules.required]" @click.native="enableSave()" />
                </v-col>

                <!-- zip -->
                <v-col cols="6">
                  <v-text-field type="number" :label="$t('label.zip')" v-model="account.zip" :rules="[rules.required]" @click.native="enableSave()" />
                </v-col>
                <!-- timezone -->
                <v-col cols="6">
                  <v-select
                    v-model="account.timeZone"
                    :items="zones"
                    item-text="zone" item-value="zone"
                    label="Timezone"
                    @click.native="enableSave()">

                  </v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="onCancel">{{$t('label.cancel')}}</v-btn>
            <v-btn color="blue darken-1" type="submit" :disabled="saveDisabled">{{$t('label.save')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "EditAccount",
  data() {
    return {
      saveDisabled: true,
      rules: {
        required: value => !!value || "Required."
      },
      zones: [
        { zone: "US/Alaska" },
        { zone: "US/Aleutian" },
        { zone: "US/Arizona" },
        { zone: "US/Central" },
        { zone: "US/East-Indiana" },
        { zone: "US/Eastern" },
        { zone: "US/Hawaii" },
        { zone: "US/Indiana-Starke" },
        { zone: "US/Michigan" },
        { zone: "US/Mountain" },
        { zone: "US/Pacific" },
        { zone: "US/Pacific-New" },
        { zone: "US/Samoa" },
        { zone: "Africa/Abidjan" },
        { zone: "Africa/Accra" },
        { zone: "Africa/Addis_Ababa" },
        { zone: "Africa/Algiers" },
        { zone: "Africa/Asmara" },
        { zone: "Africa/Asmera" },
        { zone: "Africa/Bamako" },
        { zone: "Africa/Bangui" },
        { zone: "Africa/Banjul" },
        { zone: "Africa/Bissau" },
        { zone: "Africa/Blantyre" },
        { zone: "Africa/Brazzaville" },
        { zone: "Africa/Bujumbura" },
        { zone: "Africa/Cairo" },
        { zone: "Africa/Casablanca" },
        { zone: "Africa/Ceuta" },
        { zone: "Africa/Conakry" },
        { zone: "Africa/Dakar" },
        { zone: "Africa/Dar_es_Salaam" },
        { zone: "Africa/Djibouti" },
        { zone: "Africa/Douala" },
        { zone: "Africa/El_Aaiun" },
        { zone: "Africa/Freetown" },
        { zone: "Africa/Gaborone" },
        { zone: "Africa/Harare" },
        { zone: "Africa/Johannesburg" },
        { zone: "Africa/Juba" },
        { zone: "Africa/Kampala" },
        { zone: "Africa/Khartoum" },
        { zone: "Africa/Kigali" },
        { zone: "Africa/Kinshasa" },
        { zone: "Africa/Lagos" },
        { zone: "Africa/Libreville" },
        { zone: "Africa/Lome" },
        { zone: "Africa/Luanda" },
        { zone: "Africa/Lubumbashi" },
        { zone: "Africa/Lusaka" },
        { zone: "Africa/Malabo" },
        { zone: "Africa/Maputo" },
        { zone: "Africa/Maseru" },
        { zone: "Africa/Mbabane" },
        { zone: "Africa/Mogadishu" },
        { zone: "Africa/Monrovia" },
        { zone: "Africa/Nairobi" },
        { zone: "Africa/Ndjamena" },
        { zone: "Africa/Niamey" },
        { zone: "Africa/Nouakchott" },
        { zone: "Africa/Ouagadougou" },
        { zone: "Africa/Porto-Novo" },
        { zone: "Africa/Sao_Tome" },
        { zone: "Africa/Timbuktu" },
        { zone: "Africa/Tripoli" },
        { zone: "Africa/Tunis" },
        { zone: "Africa/Windhoek" },
        { zone: "Brazil/Acre" },
        { zone: "Brazil/DeNoronha" },
        { zone: "Brazil/East" },
        { zone: "Brazil/West" },
        { zone: "Europe/London" },
        { zone: "Israel" },
        { zone: "UTC" }
      ]
    };
  },
  props: {
    error: {},
    account: {},
    loading: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSubmit() {
      this.saveDisabled = true;
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.$emit("onConfirmed", this.account);
    },
    onCancel() {
      this.loading = false;
      this.saveDisabled = true;
      this.$emit("onCancelled");
    },
    enableSave() {
      this.saveDisabled = false;
    }
  },
  created: function() {}
};
</script>